export default {
  brand: 'mediatik',
  domain: 'mediatik.ru',
  title: 'mediatik.ru — запись и обрезка аудио, запись видео',
  description: 'Бесплатные инструменты для записи голоса, обрезки аудио и записи круглого видео прямо в браузере без загрузки файлов на сервер.',
  metrikaId: '111276400',
  ogImage: 'https://mediatik.ru/og-image.png',
}
